export const TICK = '/svg/tick.svg'
